// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__C8YmT","overflowing":"ReadFullNote_overflowing__9n5yy"};